export default class AuthModel {
    id = 0;
    pid = 0;
    name = "";
    url = "";
}